import React from 'react'
import EnergyBreadCrumb from './EnergyBreadCrumb';
import RenewableEnergy from './RenewableEnergy';
function RenewableEnergyPage() {
    return ( 
        <div className = "container-fluid">
           <EnergyBreadCrumb />
           <RenewableEnergy />
        </div>
     );
}

export default RenewableEnergyPage;